/**
 * Espelha NFSeEntradaOcorrenciaCriarRequest da API RepoDFSe: anotação do usuário no histórico do serviço tomado.
 * Tipo, origem e usuário são postos pelo servidor.
 */
export class NFSeEntradaOcorrenciaCriarRequest {
  /** Texto do usuário, até 1000 caracteres. */
  descricao: string;
  /** Data do fato, sem futuro; ausente = agora. */
  dataOcorrencia: Date | null = null;
}
